import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import tractor1 from '../images/tractor1.png'
import tractor2 from '../images/tractor2.png'
import drip from '../images/drip.png'
import box from '../images/box.png'
import box1 from '../images/box1.png'
import layer6 from "../images/layer6.png"
import e_logo from "../images/e_logo.png"
import rezscr1 from '../images/rezscr1.jpg'
import fountainscr from '../images/fountainscr.jpg'
import WOW from 'wowjs';
import { useEffect } from "react";

const Home = () => {
    useEffect(() => {

    //document.getElementsByClassName("bg-video")[0].style.display="none";
    //document.getElementsByClassName("sectionn")[0].style.display="none";

  new WOW.WOW({
    live: true
}).init();

  let slides = document.getElementsByClassName("mySlides");
    slides[1].style.display = "block";
  const showSlides= async ()=> {
  let i;
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  slideIndex++;
  if (slideIndex > slides.length) {slideIndex = 1}
  slides[slideIndex-1].style.display = "block"; 
}
   const timer = setInterval(showSlides, 8000); // Change image every 2 seconds
   return () => clearInterval(timer);
   showSlides();
}, []);

  window.onload = ()=>{}

  let slideIndex = 0;




   return (
<div>
<div className="slideshow-container">

  <div className="mySlides fade">
    <div className="numbertext">1 / 3</div>
    <img src={rezscr1}></img>
    <div className="text">Earn daily PLS ; even with minimal participation in RESERVOIR</div>
  </div>

  <div className="mySlides fade">
    <div className="numbertext">2 / 3</div>
    <img src={fountainscr}></img>
    <div className="text">Accumulate PLS passively, convert LP token to PLS</div>
  </div>

  <div className="mySlides fade">
    <div className="numbertext">3 / 3</div>
    <img src={rezscr1}></img>
    <div className="text"> Connect wallet to begin</div>
  </div>

  <div className="mySlides fade">
    <div className="numbertext">Support</div>
    <div className="text"> Contact support: zossedev@gmail.com </div>
  </div>

 </div>

</div>);
};

export default Home;